import { NAVIGATION, type NavigationAction } from '~/reducers/nav/types';

import { type EnvActions, type EnvState, SET_PHONE_LANGUAGE } from './types';

const initialState: EnvState = {
  osType: 'none',
  osVersion: 'none',
  appVersion: 'none',
  deviceId: '',
  deviceManufacturer: 'none',
  deviceModel: 'none',
  country: 'US',
  phoneLanguage: '',
};

export const envReducer = (
  state = initialState,
  action: NavigationAction | EnvActions,
): EnvState => {
  switch (action.type) {
    case NAVIGATION:
      return {
        ...state,
        osType: action.context.query?.osType ?? state.osType,
        osVersion: action.context.query?.osVersion ?? state.osVersion,
        deviceId: action.context.query?.deviceId ?? state.deviceId,
        appVersion: action.context.query?.appVersion ?? state.appVersion,
        deviceManufacturer:
          action.context.query?.deviceManufacturer ?? state.deviceManufacturer,
        deviceModel: action.context.query?.deviceModel ?? state.deviceModel,
        country: action.context.query?.country ?? state.country,
      };
    case SET_PHONE_LANGUAGE:
      return {
        ...state,
        phoneLanguage: action.phoneLanguage,
      };
    default:
      return state;
  }
};
